/**
 * useReducedMotion — respects OS `prefers-reduced-motion` setting
 * useMotionVariants — picks between full/reduced variant sets
 */

import { useState, useEffect } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return reduced;
}

export function useMotionVariants<T>(full: T, reduced: T): T {
  const isReduced = useReducedMotion();
  return isReduced ? reduced : full;
}
